import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import systemMetricsComponent from './system-metrics.component';
import systemMetricsService from './system-metrics.service';

export default
  angular.module('components.reports.systemMetrics', [
    uiRouter
  ])
    .component('systemMetrics', systemMetricsComponent)
    .service('SystemMetricsService', systemMetricsService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('systemMetrics', {
          parent: 'reports',
          url: '/system-metrics',
          component: 'systemMetrics',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/system-metrics/system-metrics.module.js